import router from '../../router/index';

document.addEventListener('DOMContentLoaded', () => {
    document.body.addEventListener('click', event => {
        try{
            let targetElement = event.target;
            do{

                // Aタグで有効なhrefパスが設定されている
                if (targetElement.tagName === 'A'
                    && targetElement.href
                    && !targetElement.href.startsWith('#')
                    && !targetElement.pathname.startsWith('/progressive/')
                ) {

                    let routerLink = false;
                    for (let i = 0; i < targetElement.attributes.length; i++) {
                        if (targetElement.attributes[i].name.startsWith('data-v-')) {
                            routerLink = true;
                            break;
                        }
                    }

                    // vueルーティングのガード
                    if( routerLink ) continue;
    
                    const baseUrl = `${window.location.protocol}//${window.location.host}`;
                    const targetUrl = new URL(targetElement.href, baseUrl);

                    if( targetUrl.host === window.location.host){
                        const sourceURL = targetElement.href; // targetUrl.pathname + targetUrl.search + targetUrl.hash
                        router.replace({ name: 'contentViewer', query: { page_uri: sourceURL, _r: Date.now() } });    
                    } else {
                        alert('外部サイトに移動します');
                        window.open(targetUrl.href, '_blank');
                    }
            
                    // イベントキャンセル
                    event.preventDefault();
                    return;
                }

            }while( ( targetElement = targetElement.parentElement ) != null )

        }catch(err){
            console.log(err);
        }
    });
});